module.exports = __webpack_public_path__ + "static/media/theirtube_backend.46257f5e.gif";